export default "__VITE_ASSET__uyLbLupw__"